import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    header: {
        wordBreak: 'break-all',
        color: '#232323',
        fontSize: 24,
        fontWeight: 700,
        lineHeight: '36px'
    },
    added: {
        background: '#E5F6ED'
    },
    removed: {
        background: '#FFEBED'
    }
});
